module.exports = "<div *ngIf=\"isLoaded\">\n  <app-worker-schedule [data]=\"jobData\"></app-worker-schedule>\n</div>"